import { render, staticRenderFns } from "./LabAboutPage.vue?vue&type=template&id=7bd29514&scoped=true&"
import script from "./LabAboutPage.vue?vue&type=script&lang=js&"
export * from "./LabAboutPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd29514",
  null
  
)

export default component.exports